import React from 'react';

function CloseIcon(props) {
  return (
    <svg
    width={35}
    height={35}
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.64258 8.34985L26.6131 25.3204L25.8418 26.0918L8.87119 9.12124L9.64258 8.34985Z"
      fill="#5E5E5E"
    />
    <rect
      x={8.87109}
      y={25.3201}
      width={24}
      height={1.09091}
      transform="rotate(-45 8.87109 25.3201)"
      fill="#5E5E5E"
    />
  </svg>
  );
}

export default CloseIcon;